<template>
    <div>
        <!-- <a class="float-btn round whatsapp-btn" href="https://api.whatsapp.com/send?phone=551135045941" target="_blank" v-if="!totem">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path style="fill:white;" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
            </svg>
        </a> -->
        <a class="float-btn reveal reload-btn" @click="reloadPage">
            <font-awesome-icon icon="redo" />
            <span>RECARREGAR</span>
        </a>
        <div class="col-12 footersite" id="footersite">
            <div class="footer-coluna">
               <!-- <span><strong><a class="link-footer" href="https://api.whatsapp.com/send?phone=551135045941" target="_blank">Contato: (11) 3504 5941</a></strong></span> -->
               <span><a class="link-footer">Contato: (11) 3112 0698</a></span>
            </div>
            <div class="footer-coluna">
                <div class="footer-redes-sociais-container">
                    <a href="https://www.facebook.com/cartoriosdeprotestobr/" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/facebook.svg" width="13px">
                    </a>
                    <a href="https://www.instagram.com/cartprotestobr/" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/instagram.svg" width="20px">
                    </a>
                    <a href="https://www.linkedin.com/company/ieptb-br/" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/linkedin.svg" width="20px">
                    </a>
                    <!-- <a href="https://twitter.com/IeptbPR" target="_blank" >
                        <img @click="go(menu[0][menuItem()])" src="~@/assets/imgs/icons/twitter.svg" width="20px">
                    </a> -->
                </div>
            </div>
            <div class="footer-coluna">
                <span>Copyright © {{ new Date().getFullYear() }} Cartórios de Protesto - Instituto de Protesto IEPTB</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['totem'],
    methods:{
        reloadPage(){
            window.location.reload(true);
        }
    }
}
</script>
<style scoped>
.float-btn{
    z-index:100;
    display: flex;
    position: fixed;
    height: 60px;
    box-shadow: 0px 0px 11px 0px #00000080;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font: normal normal bold 15px/15px 'Kanit', sans-serif;
}
.float-btn.round{
    border-radius: 100%;
    width: 60px;
    height: 60px;
}
    .float-btn.reveal span{
        height:inherit;
        width:fit-content;
        display:flex;
        background-color:inherit;
        opacity:0.8;
        align-items:center;
        font: normal normal bold 12px/12px 'Kanit', sans-serif;
        padding:0 18px;
    }
    .float-btn.reveal:hover{
        text-decoration:none;
    }
    .float-btn.reveal svg{
        height:inherit;
        display:flex;
        background-color:inherit;
        align-items:center;
        padding:0 24px;
        font-size:24px;
        width:24px;
    }
        .whatsapp-btn{
            bottom: 40px;
            left: 4px;
            background-color: #25D366;
        }
            .whatsapp-btn svg{
                width: 50%;
            }
        .reload-btn{
            top: 160px;
            right: calc(72px - 186.03px);
            color:#FFFFFF;
            width:fit-content;
            background-color: #FFFFFF;
            transition:all 0.45s ease-in-out;
        }
            .reload-btn:hover{
                right: 0px;
            }
            .reload-btn span{
                width:70px;
                background-color: #4780f1dd !important;
            }
            .reload-btn svg{
                background-color: #4780F1 !important;
            }
.footersite{
    margin-top:10%;
    background-color:#084F84;
    height:350px;
}
.footer1site{
    background-color:#494949;
    height:80px;
}
.textorodape{
    color:white;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -1%;
    padding:0;
}
.borda{
    /* border-color: black; */
   border: 1px solid red;
}
.link-footer,
#footersite .footer-block span a,
a,
a:hover{color:#EEF1F4 !important;}

#fieldsetEstilizado{
 border: 2px green solid !important;
 border-radius: 10px;
}
/* MELHORIA */
.footersite {
    display:flex;
    padding: 40px 200px;
    flex-flow: wrap;
    font-family:'Kanit', sans-serif;
    justify-content: space-between;
}
.footersite .footer-coluna{
    width: 22%;
    display: flex;
    flex-flow: column;
    margin-bottom: 45px;
}
.footersite .footer-coluna:last-child{
    align-items: flex-end;
}
.footersite .footer-coluna .footer-logo{
    width:100%
}
.footersite .footer-coluna .footer-logo img{
    width: 150px;
}
.footersite .footer-coluna .footer-coluna-titulo{
    font-weight: 700;
    color: white;
    font-size: 16px;
    margin-bottom: 20px;
}
.footersite .footer-coluna .textolink{
    font-weight: 400;
    font-size: 14px;
    display: flex;
    margin-left: -18px;
    margin-bottom: 10px;
}
.footersite .footer-coluna .textolink:before, .footer-contato-card .texto-contato .texto-contato-telefone:before{
    content: "";
    width: 8px;
    height: 1px;
    background-color: white;
    align-self: center;
    margin-right: 10px;
}
.footer-contato-card{
    margin-bottom: 50px;
    margin-left: -18px;
}
.footer-contato-card .texto-contato{
    font-size: 14px;
    color: white;
    display: flex;
    flex-flow: column;
}
.footer-contato-card .texto-contato .texto-contato-telefone{
    display: flex;
    margin-bottom:5px;
    letter-spacing: 2px;
}
.footer-contato-card .texto-contato .texto-contato-telefone div{
    letter-spacing: normal;
    margin-left: 10px;
    font-weight: 600;
}
.footer-contato-card .texto-contato .texto-contato-descricao{
    margin-left: 18px;
    padding-right: 25px;
    text-transform: none;
}
.footer-redes-sociais-container{
    display: flex;
    align-items: center;
}
.footer-redes-sociais-container a{
    margin-left: 30px;
}
.footer-redes-sociais-container img{
    width: auto;
    height: 24px;
}
@media (max-width: 1199px) {
    
	.footersite{display: none !important;}
    .footersite .footer-coluna{
        width: 250px;
        margin-right: -65px;

    }
    .footersite .footer-coluna:last-child{
        align-items: flex-start;
    }
    .footer-redes-sociais-container a{
        margin-left:0;
        margin-right: 30px;
    }
}
</style>